import { atom } from "jotai";
import { Node } from "@xyflow/react";
import {
  emitEventOnStartingOverSetter,
  createNewCanvasSetter,
  clearCanvasSetter,
  closeSidebarSetter,
  canvasIdAtom,
} from "@zapier/canvas-state";

import { aiPromptAtomResettable } from "./aiPromptAtom";

export const startOverSetter = atom(
  null, // Read function (no value needed)
  // Write function (this is the actual start over implementation now)
  async (get, set, centerAndZoomOnNode: (node: Node) => void) => {
    const canvasId = get(canvasIdAtom);

    // Template and AI page both don't have real canvas
    if (!canvasId) {
      await set(emitEventOnStartingOverSetter);
      setTimeout(() => {
        // createNewCanvasSetter creates a new canvas and routes to it - only use when you don't have a real canvas
        set(createNewCanvasSetter, {
          nodes: [],
          edges: [],
          options: { skipBeforeUnloadCheck: true },
        });
      }, 0);
      return;
    }

    // Logic for non-AI page start over
    set(clearCanvasSetter, centerAndZoomOnNode);
    set(closeSidebarSetter);
    set(aiPromptAtomResettable, "");
    await set(emitEventOnStartingOverSetter);
  },
);

startOverSetter.debugLabel = "startOverSetter";
